import React from 'react';
import { PageHeader } from '../components/UI';
import Llm from '../components/Llm';
import { useTranslation } from '../contexts/LanguageContext';

const LlmPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="p-6 max-w-[1920px] mx-auto space-y-6">
      <PageHeader 
        title="LLM Assistant" 
        breadcrumbs={[{ label: 'Main' }, { label: 'LLM Assistant' }]}
      />
      
      <Llm />
    </div>
  );
};

export default LlmPage;
